import clsx from "clsx";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import type { Components } from "react-markdown";

type MarkdownProps = {
    testId?: string;
    className?: string;
    children: string;
};

const components: Components = {
    table: ({ children }) => (
        <div className="my-4 overflow-x-auto">
            <table className="min-w-full border-collapse border border-slate-700">
                {children}
            </table>
        </div>
    ),
    thead: ({ children }) => <thead className="bg-slate-800">{children}</thead>,
    tbody: ({ children }) => <tbody>{children}</tbody>,
    tr: ({ children }) => (
        <tr className="border-b border-slate-700">{children}</tr>
    ),
    th: ({ children }) => (
        <th
            className={clsx(
                "px-4 py-2",
                "border border-slate-700",
                "text-left font-semibold",
            )}
        >
            {children}
        </th>
    ),
    td: ({ children }) => (
        <td className="border border-slate-700 px-4 py-2">{children}</td>
    ),
};

export function Markdown({ testId, className, children }: MarkdownProps) {
    return (
        <ReactMarkdown
            className={clsx(
                className,
                "text-defaultTextColor",
                "font-body",
                "font-bodyWeight",
                "text-bodyMSize",
                "leading-bodyM",
                "tracking-body",
                "cursor-default",
            )}
            components={components}
            remarkPlugins={[remarkGfm]}
            data-testid={testId}
        >
            {children}
        </ReactMarkdown>
    );
}
